<template>
  <div>
    <div v-if="listOk" class="body">
      <div class="chat-body">
        <orderUI :info="orderInfo" v-if="orderUIShow" class="orderUI"></orderUI>
        <div v-else class="tips">客户暂未下单，只可发送{{maxSendCountClerk}}条消息</div>
        <van-list
            class="list"
            v-model="loading"
            :finished="finished"
            finished-text="没有更多了"
            @load="onLoad"
            direction="up"
            offset="10"
        >
          <div v-for="(item,index) of list" :key="index">
            <div v-if="item.roleInfo.role == 'clerk'" class="my-box">
              <div v-if="index == 0 || formatDate(item.message.sendTime) != formatDate(list[index - 1].message.sendTime)"
                   class="date">{{ formatDate(item.message.sendTime, 'MM-DD HH:mm') }}
              </div>
              <div class="my">

                <RenderMessage :message="item.message" :direction="true" backgroundColor="#B687FC" fontColor="#fff"></RenderMessage>
              </div>
            </div>

            <div v-if="item.roleInfo.role == 'user'" class="you-box">
              <div v-if="index == 0 || formatDate(item.message.sendTime) != formatDate(list[index - 1].message.sendTime)"
                   class="date">{{ formatDate(item.message.sendTime, 'MM-DD HH:mm') }}
              </div>
              <div class="you">
                <div class="head">
                  <img v-if="info.avatarUrl" :src="info.avatarUrl">
                </div>
                <div style=" display: flex;align-items: center;justify-content: right;">
                  <RenderMessage :message="item.message" :direction="false"></RenderMessage>
                  <div v-if="!item.message.readStatus && item.message.type == 3" style="width: 2.4vw;height:2.4vw;background: #FD2C55;border-radius: 100px"></div>
                </div>
              </div>
            </div>
          </div>

          <div slot="loading"></div>
          <div slot="finished"></div>
          <div slot="error"></div>
        </van-list>
      </div>
      <div class="bottom-box">
        <div class="shortcut" @click="shortcut">
          <div class="text">{{listData&&listData.length>0?listData[0].content:''}}</div>
          <div class="l"></div>
          <div class="script" @click.stop="showPopup">
            <div>快捷话术</div>
            <img src="/static/images/2184/chat/s.png"/>
          </div>
        </div>
        <div class="input-box">
          <template v-if="message.msgType===1">
            <img src="/static/images/2184/chat/audio.png" class="audio" @click="selectType(3)"/>
            <van-field class="input" :autosize="{ maxHeight: 100 }" rows="1" type="textarea" v-model="message.body.content" />
            <div class="sending" @click="sendingV2">发送</div>
          </template>
          <template v-if="message.msgType===3">
            <img src="/static/images/2184/chat/text.png" class="audio" @click="selectType(1)"/>
            <div class="audio-input" ref="audioInput"   @mousedown="startTimer"
                 @mouseup="clearTimer"
                 @touchstart="startTimer"
                 @touchend="clearTimer"
                 @touchmove="handleTouchMove"
            >按住 说话</div>
          </template>
        </div>
      </div>

      <van-popup class="kjPopup" v-model="kjShow" position="bottom" :style="{ height: '112.5vw' }">
        <div class="title">
          <span>快捷话术</span>
          <img class="x" @click.stop="kjShow = false" src="/static/images/2184/chat/x.png"/>
        </div>
        <div class="popBox">
          <div class="pop-body" v-if="listData && listData.length > 0">
            <div class="kjItem" :class="content == item.content ? 'kjClick' : ''" v-for="(item, index) in listData" :key="index" @click="selectItem(item)">
              <span>{{item.content}}</span>
              <img v-if="content == item.content" class="y" src="/static/images/2184/chat/y.png"/>
            </div>
          </div>
          <div class="pop-body" v-else>
            <div class="kjItem">
              <span>暂未设置话术</span>
            </div>
          </div>
          <div class="block"></div>
        </div>
        <div :class="content == '' ? 'bottom-button1' : 'bottom-button2'" @click="fs">发送</div>
      </van-popup>

      <!-- 圆角弹窗（底部） -->
      <van-popup ref="audioPopup"
                 v-model="audioModel.show"
                 round
                 position="bottom" @closed="audioFork"
                 :style="{ height: '47vw' }" >
        <div v-if="audioModel.show"  :style="{'background-color': audioModel.isSendAudio ?  '#E8E9EB':'#fc0053' }" @click="audioFork"
             style="position: absolute; top: -8vw; left:50%; transform: translate(-50%, -100%); width: 19.6vw;height: 19.6vw;background-color: #E8E9EB;border-radius: 200px;justify-content: center; align-items: center; display: flex;">
          <img style="width: 3.6vw" src="/static/images/2184/chat/audio-fork.png">
        </div>
        <div style="width: 100%;display: flex; flex-direction: column; align-items: center;">
          <img style="width: 61.3vw;margin-top: 5vw" src="/static/images/2184/chat/audio-strip.gif">
          <div style="margin-top: 4.4vw;font-size: 3.7vw;color: #333333;">松开手指，发送语音</div>
        </div>
      </van-popup>

    </div>
    <div class="jz" v-show="!listOk">加载中</div>
  </div>
</template>


<script>
import Vue from 'vue';
import {
  Field,
  Button,
  List,
  Cell,
  CellGroup,
  Tag,
  Icon,
  ActionSheet,
  Dialog,
  Tab,
  Tabs, Popup, Toast, Picker
} from 'vant';
import moment from "moment";
import orderUI from "@/views/2184/clerk/chat/component/orderUI"
import {getList, sendMessage,sendMessageV2, read, markRead} from "@/api/clerk/chat-message";
import {getLatestOrderInfo} from "@/api/clerk/chat-room";
import {getSocketInstance, addRoomData, closeReconnect, closeWebSocket,addToMaxSizeArray,clearChatData} from "@/api/clerk/chat-websocket";
import Decimal from "decimal.js";
import RenderMessage from '@/views/2184/clerk/chat/component/renderMessage'

import {wx, wxConfig} from "@/libs/jssdk-util";
import {audioToMp3, wxAudioMediaIdToMp3} from "@/api/file"
import {getRoomId,createRoom,getChatAutoMessage} from "@/api/clerk/chat-room";

Vue.use(Button)
    .use(List)
    .use(Cell)
    .use(CellGroup)
    .use(Tag)
    .use(Icon)
    .use(ActionSheet)
    .use(Dialog)
    .use(Tab)
    .use(Tabs)
    .use(Popup)
    .use(Picker)
    .use(Field)


export default {
  name: 'chat',
  components: {
    orderUI
    ,RenderMessage
  },
  data() {
    return {
      listOk: false,
      content: '',
      kjShow: false,
      maxSendCountClerk: null,
      id: this.$route.query.id,
      userId: this.$route.query.userId,
      orderNo: this.$route.query.orderNo,
      info: null,
      clerkData: null,
      buttomType: false,
      sendingType: true,
      positionType: false,
      position1: null,
      position2: null,
      list: [],
      value: '',
      loading: false,
      finished: false,
      pageNo: 1,
      pageSize: 15,
      cursor: null,
      orderInfo: {},
      orderUIShow: false,
      isCanChat:false,//是否可以聊天

      // 消息类型
      message: {
        msgType: 1,
        body: {
          content:null
        },
      },

      //音频弹窗
      audioModel: {
        show: false,
        isSendAudio: true,
      },

      record: {
        isRecording: false,
        countdown: 20,
        _countdown: 20,
        countdownTimer: null,
        audioLocalId: null, // 音频本地ID
        audioServerId: null, // 音频服务器ID
      },
      showListPopup: false,
      listData: []
    }
  },
  watch: {
    list: function () {
      this.$nextTick(() => {
        this.positioning()
      });
    },
    value: function () {
      if (this.value == '') {
        this.buttomType = false
      } else {
        this.buttomType = true
      }
    },
    '$store.state.chat.messageResp'(messageResp) {//收到新消息
      this.pushMessage(messageResp)
    }
  },
  methods: {
    shortcut(){
      if(!this.listData || this.listData.length === 0){return}
      this.message.body.content = this.listData[0].content
      this.sendingV2()
    },
    showPopup() {
      this.chatAutoMessage()
      this.kjShow = true; // 显示弹窗
    },
    chatAutoMessage(){
      if(this.listData.length === 0) {
        getChatAutoMessage("chat_auto_message").then(res => {
          const data = res.data;
          if (data.code === 0) {
            this.listData = data.list;
          }
        })
      }
    },
    selectItem(item) {
      this.content = item.content; // 将选中的内容放入输入框
    },
    fs(){
      if(this.content == ''){
        return
      }
      this.message.body.content = this.content
      this.kjShow = false
      this.sendingV2()
    },
    closePopup() {
      this.showListPopup = false; // 关闭弹窗
    },
    selectType(type){
      this.message.msgType=type
      this.clearTypeContent(type)
    },
    clearTypeContent(type){
      if (1 === type) {
        this.message.body = {content: null}
      } else if (3 === type) {
        this.message.body = {audioBase64: null}
        this.getRecordPermission()
      }
    },

    handleTouchMove(event) {
      const audioForkRect = this.$refs.audioInput.getBoundingClientRect();
      const touchX = event.touches[0].clientX;
      const touchY = event.touches[0].clientY;
      // 检查手指是否在audio-fork图标附近
      if (
          touchX >= audioForkRect.left &&
          touchX <= audioForkRect.right &&
          touchY >= audioForkRect.top &&
          touchY <= audioForkRect.bottom
      ) {
        this.audioModel.isSendAudio = true;
      } else {
        const audioForkRectPopup = this.$refs.audioPopup.$el.getBoundingClientRect();
        if (
            touchX >= audioForkRectPopup.left &&
            touchX <= audioForkRectPopup.right &&
            touchY >= audioForkRectPopup.top &&
            touchY <= audioForkRectPopup.bottom
        ){
          this.audioModel.isSendAudio = true;
        }else {
          this.audioModel.isSendAudio = false;
        }

      }
    },
    audioFork(){
      this.audioModel.isSendAudio=false
      this.clearTimer()
    },
    //长按
    startTimer() {
      this.audioModel.show=true
      this.handleRecordStart();
    },
    //取消长按
    clearTimer() {
      this.audioModel.show=false
      this.handleRecordStop(this.audioModel.isSendAudio)
      this.audioModel.isSendAudio=true
    },
    //触发获取录音权限
    getRecordPermission(){
      wx.startRecord({
        success: function () {
          wx.stopRecord()
        },
        fail(err) {
          Dialog.alert({
            title: '获取权限失败',
            message: err.errMsg
          })
        }
      })
    },
    // 开始录音
    handleRecordStart() {
      let that = this
      wx.startRecord({
        success: function () {
          clearInterval(that.record.countdownTimer)
          that.record.isRecording = true
          // 倒计时结束自动停止录音
          that.record.countdown = that.record._countdown
          that.record.countdownTimer = setInterval(() => {
            that.record.countdown--
            if (that.record.countdown <= 0) {
              clearInterval(that.record.countdownTimer)
              that.handleRecordStop(true)
            }
          }, 1000)
        },
        fail(err) {
          that.record.isRecording = false
          Dialog.alert({
            title: '开始录音失败',
            message: err.errMsg
          })
        }
      })
    },
    // 停止录音
    handleRecordStop(isUploadVoice) {
      let vm = this
      if (this.record.isRecording) {
        this.record.isRecording = false
        Toast.loading({
          mask: true,
          duration: 0,
          message: '音频上传中'
        })
        wx.stopRecord({
          success: function (res) {
            if (!isUploadVoice){
              Toast.clear()
              Toast('取消发送')
              return;
            }
            wx.uploadVoice({
              localId: res.localId,
              isShowProgressTips: 1, // 默认为1，显示进度提示
              success(res) {
                const mediaId = res.serverId
                wxAudioMediaIdToMp3(mediaId).then(res => {
                  Toast.clear()
                  const data = res.data;
                  if (data.code == 0) {
                    const base64 = 'data:audio/mpeg;base64,' + data.audio
                    vm.message.body.audioBase64 = base64
                    Toast.loading({mask: true, message: '发送中'})
                    vm.sendingV2();
                  } else {
                    Dialog.alert({
                      title: '上传音频失败',
                      message: data.msg
                    })
                  }
                })
              },
              fail(err) {
                Toast.clear()
                Dialog.alert({
                  title: '上传录音失败',
                  message: err.errMsg
                })
              }
            })
          },
          fail(err) {
            Toast.clear()
            Dialog.alert({
              title: '停止录音失败',
              message: err.errMsg
            })
          }
        })
      }
    },

    formatAudioDuration(duration) {
      if (duration != null) {
        duration = Decimal.div(duration, 1000).toFixed(0)
        if (duration.length < 2) {
          duration = '0' + duration
        }
        return duration + 's'
      }
      return ''
    },

    //修改成已读
    updateRead() {
      this.list.forEach(i => {
        if (i.roleInfo.role === 'user') {
          i.message.readStatus = true
        }
      })
    },
    /**
     * 标记全部消息已读
     */
    isReads() {
      read(this.id).then(res => {
        const data = res.data;
        if (data.code != 0){
          Dialog.alert({
            title: '已读失败',
            message: data.msg
          })
        }else {
          this.updateRead()
        }
      })
    },
    /**
     * 标记单条消息已读
     */
    markReadEvent(ids) {
      markRead(this.id, ids).then(res => {
        const data = res.data;
        if (data.code != 0) {
          Dialog.alert({
            title: '已读失败',
            message: data.msg
          })
        }else {
          this.updateRead()
        }
      })
    },
    onLoad(resetFirstPage) {
      if (!this.id){
        return;
      }
      // 重置为首页
      if (resetFirstPage) {
        this.cursor = null
        this.positionType = false
        this.list = [];
      } else {
        this.positionType = true
      }
      this.loading = true
      getList({
        roomId: this.id,
        cursor: this.cursor,
        pageSize: this.pageSize,
      }).then(res => {
        this.loading = false
        const data = res.data;
        if (data.code == 0) {
          this.listOk = true
          this.list = data.list.concat(this.list)
          this.cursor = data.cursor
          if (data.isLast) {//是否是最后一页
            this.finished = true
          } else {
            this.finished = false
          }
        } else {
          this.finished = true
          Dialog.alert({
            title: '加载失败',
            message: data.msg
          })
        }
      }).catch(res =>{
        this.finished = true
        Dialog.alert({
          title: '加载失败',
        })
      })
    },
    positioning() {
      if (!this.positionType) {
        document.querySelector('.list').scrollTo(0, document.querySelector('.list').scrollHeight - document.querySelector('.list').clientHeight);
        this.position1 = document.querySelector('.list').scrollHeight
      } else {
        this.position2 = document.querySelector('.list').scrollHeight
        document.querySelector('.list').scrollTo(0, this.position2 - this.position1);
        this.position1 = this.position2
      }
    },
    formatDate(date, format) {
      if (!date) {
        return '';
      }
      if (!format) {
        format = 'YYYY-MM-DD'
      }
      return moment(date).format(format);
    },
    /**
     * 发送消息
     */
    sending() {
      if (this.value.length > 0) {
        if (this.sendingType) {
          this.positionType = false
          sendMessage(this.id, this.value
          ).then(res => {
            const data = res.data;
            if (data.code == 0) {
              this.list = this.list.concat(data.messageResp)
              this.sendingType = false
              setTimeout(() => {
                this.sendingType = true
              }, 5000);
              this.sendMessageEvent(data.messageResp)
            } else {
              Dialog.alert({
                title: '发送失败',
                message: data.msg
              })
            }
          })
        } else {
          Toast('操作过于频繁');
        }
      } else {
        Toast('请输入内容');
      }
    },
    sendingV2() {
      if (!this.id){
        return Toast('暂无房间号，请退出页面重试');
      }
      if (!this.sendingType){
        return Toast('操作过于频繁');
      }
      if (this.message.msgType !== 1 && this.message.msgType !== 3) {
        return Toast('消息类型异常');
      }
      if (this.message.msgType === 1 && this.message.body.content.length <= 0) {
        return Toast('请输入内容');
      }
      let data = {
        roomId: this.id,
        msgType: this.message.msgType,
        body: this.message.body
      };
      this.positionType = false
      sendMessageV2(data).then(res => {
        const data = res.data;
        Toast.clear()
        if (data.code == 0) {
          this.list = this.list.concat(data.messageResp)
          this.clearTypeContent(this.message.msgType)
          this.sendingType = false
          setTimeout(() => {
            this.sendingType = true
          }, 5000);
          this.sendMessageEvent(data.messageResp)
        } else {
          Dialog.alert({
            title: '发送失败',
            message: data.msg
          })
        }
      })
    },
    /**
     * 获取订单消息
     */
    getLatestOrderInfo() {
      getLatestOrderInfo({
        userId: this.info.roleId
      }).then(res => {
        const data = res.data;
        if (data.code == 0) {
          if(data.user){
            document.title = data.user.nickname
          }
          this.orderInfo = data
          this.orderUIShow = data.isOrder
          this.isCanChat=data.isCanChat
          this.maxSendCountClerk = data.maxSendCountClerk
        } else {
          Dialog.alert({
            title: '获取失败',
            message: data.msg
          })
        }
      })
    },
    /**
     * 将消息保存到聊天记录列表
     */
    pushMessage(messageResp) {
      if (this.id == messageResp.roomId) {
        //消息存入会话，新消息更新成为已读，未读数量设置为0
        this.list.push(messageResp)
        this.$store.state.chat.roomData.find(item => item.roomId == this.id).unreadCount = 0
        let ids = []
        ids.push(messageResp.message.id)
        this.markReadEvent(JSON.stringify(ids))
      }
    },
    sendMessageEvent(messageResp) {
      let roomList = this.$store.state.chat.roomData
      roomList.forEach((item) => {
        if (item.roomId === messageResp.roomId) {
          item.text = messageResp.message.content
          item.activeTime = messageResp.message.sendTime
          addToMaxSizeArray(item, messageResp)
        }
      });
    },
    /**
     * 获取角色信息
     */
    async getRoleInfo(id) {
      let info = this.$store.state.chat.roomRoleInfoMap.get(id + '')
      if (info == null) {
        await addRoomData(id, this.$store);//获取房间信息
        info = this.$store.state.chat.roomRoleInfoMap.get(id + '')
      }
      this.info = info
      this.getLatestOrderInfo()
    },

    getRoomId(userId) {
      return new Promise((resolve) => {
        // 第一个方法的代码
        getRoomId({
          userId: userId
        }).then(res => {
          const data = res.data;
          if (data.code == 0) {
            if (data.roomId){
              this.id=data.roomId
              resolve(data.roomId);
            }else {
              resolve(this.createRoom(userId));
            }
          } else {
            Dialog.alert({title: '获取房间号失败', message: data.msg})
          }
        })
      });
    },
    createRoom(userId) {
      return new Promise((resolve) => {
        // 第一个方法的代码
        createRoom({
          userId: userId,
        }).then(res => {
          const data = res.data;
          if (data.code == 0) {
            this.id=data.roomId
            resolve(data.roomId);
          } else {
            Dialog.alert({title: '获取房间号失败', message: data.msg})
          }
        })
      });
    },

    //渲染页面
    renderPage(roomId) {
      this.onLoad(true)
      this.getRoleInfo(roomId)
      setTimeout(() => {
        let roomInfo = this.$store.state.chat.roomData.find(item => item.roomId === roomId);
        if (roomInfo!=null&&roomInfo.unreadCount !== 0) {
          this.isReads()
          roomInfo.unreadCount = 0//已读数量改为0
        }
      }, 0)//异步调用
    },

    socketInstance(s){
      getSocketInstance(s)
    }
  },
  /**
   * 不在/chat路径下关闭通话
   */
  beforeRouteLeave(to, from, next) {
    if (!to.fullPath.includes("/chat")) {
      clearChatData(this.$store)
      closeReconnect()//关闭重新连接机制
      closeWebSocket()//关闭通信
    }
    if (this.record.isRecording) {
      let that = this;
      wx.stopRecord({
        success: function () {
          that.record.isRecording = false
        }
      })
    }
    next();
  },
  activated() {
    if (this.$hasFeature('chat')) {
      this.socketInstance(this.$store)
    }
  },
  mounted() {
    this.chatAutoMessage()
    if (this.userId){
      this.getRoomId(this.userId).then((roomId) => {
        this.renderPage(roomId)
      })
    }else {
      this.renderPage(this.$route.query.id)
    }

    wxConfig(['getSetting','authorize','startRecord', 'stopRecord', 'playVoice', 'stopVoice', 'onVoicePlayEnd', 'uploadVoice'])
    wx.error(function (err) {
      Dialog.alert({
        title: '微信配置失败，请刷新页面',
        message: JSON.stringify(err)
      })
    });
  },

}
</script>

<style lang="less" scoped>
.body {
  width: 100vw;
  height: 100vh;
  background: #F2F3F5;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;

  .chat-body {
    height: calc(100% - 112px);
    width: 100vw;
    overflow-y: auto;
    position: relative;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;

    .orderUI {
      margin: 3.38vw 4.34vw 0;
      //position: fixed;
      //top: 15px;
      //left: 0;
      //right: 0;
    }
    .tips{
      height: 7.7vw;
      border-radius: 999px;
      background: #E8E9EB;
      padding: 0 3.4vw;
      font-weight: 500;
      font-size: 3.4vw;
      line-height: 7.7vw;
      color: #666;
      display: inline-block;
      margin: 2.4vw auto 0 auto;
    }
    .list {
      flex: 1;
      height: 0;
      overflow-y: scroll;

      .my-box {
        padding-bottom: 20px;

        .date {
          text-align: center;
          padding: 10px 0 13px 0;
          color: #B1B1B2;
          font-size: 2.9vw;
          font-weight: 500;
        }

        .my {
          display: flex;
          align-items: center;
          justify-content: flex-end;

          .state {
            color: #B1B1B2;
            font-size: 11px;
            font-weight: 500;
            margin-right: 7px;
          }

          .bubble {
            font-size: 13px;
            font-weight: 500;
            color: #fff;
            line-height: 20px;
            background: #5E73FA;
            padding: 10px 12px;
            max-width: 60vw;
            margin-right: 23px;
            border-radius: 20px 20px 5px 20px;
          }
          .audio {
            font-size: 13px;
            font-weight: 500;
            color: #fff;
            line-height: 20px;
            background: #5E73FA;
            padding: 10px 12px;
            max-width: 60vw;
            margin-right: 23px;
            border-radius: 20px 20px 5px 20px;
          }

        }
      }

      .you-box {
        padding-bottom: 20px;

        .date {
          text-align: center;
          padding: 10px 0 7px 0;
          color: #B1B1B2;
          font-size: 2.9vw;
          font-weight: 500;
        }

        .you {
          display: flex;

          .head {
            width: 9.3vw;
            height: 9.3vw;
            border-radius: 50%;
            overflow: hidden;
            margin: 0 3vw 0 4.2vw;
            background: #FDCC43;

            img {
              width: 100%;
              height: 100%;
              display: block;
            }
          }

          .bubble {
            margin-top: 6px;
            font-size: 13px;
            font-weight: 500;
            color: #333;
            line-height: 20px;
            background: #fff;
            padding: 10px 12px;
            max-width: 60vw;
            border-radius: 5px 20px 20px 20px;
          }

          .audio{
            margin-top: 6px;
            font-size: 13px;
            font-weight: 500;
            color: #333;
            line-height: 20px;
            background: #fff;
            padding: 10px 12px;
            max-width: 60vw;
            border-radius: 5px 20px 20px 20px;
          }
        }
      }
    }
  }
  .shortcut{
    display: flex;
    align-items: center;
    padding: 15px 16px;
    font-weight: 500;
    font-size: 14px;
    color: #808080;
    background: #fff;
    border-bottom: 1px #F5F6F7 solid;
    .text{
      flex: 1;
      overflow:hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 1;
      -webkit-box-orient: vertical;
    }
    .l{
      width: 1px;
      height: 17px;
      background: linear-gradient(0deg, #FFFFFF, #CCCCCC, #FFFFFF);
      margin-left: 14px;
    }
    .script{
      display: flex;
      align-items: center;
      color: #666;
      margin-left: 14px;
      img{
        width: 7px;
        display: block;
        margin-left: 2px;
      }
    }
  }
  .bottom-box{
    position: absolute;
    left: 0;
    bottom: 0;
  }
  .input-box {
    width: calc(100vw - 16px * 2);
    min-height: calc(15.8vw - 11px * 2);
    display: flex;
    align-items: center;
    padding: 11px 16px;
    background: #fff;

    /deep/input{
      line-height: initial;
    }

    /deep/.van-cell__value{
      display: flex;
      align-items: center;
    }
    /deep/.van-field__body{
      flex: 1;
    }
    .van-cell {
      background: #F2F3F5;
      border-radius: 5vw;
      padding: 6px 16px;
    }

    .sending {
      border-radius: 999px;
      display: flex;
      align-items: center;
      background: #B687FC;
      //background: #379FFF;
      white-space: nowrap;
      color: #fff;
      font-size: 3.4vw;
      width: 17.1vw;
      height: 9.6vw;
      line-height: 9.6vw;
      text-align: center;
      display: flex;
      justify-content: center;
    }
    .audio{
      width: 6.8vw;
      margin-right: 4.2vw;
      margin-left: 4.3vw;
    }
    .input{
      width: 59.3vw;
      min-height: 9.6vw;
      margin-right: 4.2vw;
    }

    .audio-input {
      width: 69.4vw;
      height: 9.6vw;
      line-height: 9.6vw;
      margin-right: 4.2vw;
      background-color: #F2F3F5;
      border-radius: 200px;
      text-align: center;
      font-size: 4vw;
      color: #333333;
    }
  }
}

/deep/.van-popup{
  overflow: initial;
}

/* 调整样式以匹配截图 */
.popup-content {
  padding: 20px;
  background-color: #fff;
}

.popup-title {
  font-size: 18px;
  margin-bottom: 20px;
  color: #333;
}

.custom-cell {
  font-size: 16px;
  color: #666;
  padding: 15px 0;
  border-bottom: 1px solid #eee;
}

.custom-cell:last-child {
  border-bottom: none;
}
.kjPopup{
  border-radius: 4.5vw 4.5vw 0 0;
  .title{
    height: 13vw;
    text-align: center;
    line-height: 13vw;
    font-weight: bold;
    font-size: 4vw;
    color: #333;
    position: relative;
    .x{
      width: 5.8vw;
      height: 5.8vw;
      display: block;
      position: absolute;
      top: 3.4vw;
      right: 4vw;
    }
  }
  .popBox{
    position: relative;
    .pop-body{
      padding-top: 5.6vw;
      padding-bottom: 17.6vw;
      height: calc(77vw - 5.6vw - 17.6vw);
      overflow-y: auto;
      .kjItem{
        position: relative;
        padding: 0 14.4vw;
        text-align: center;
        font-size: 4vw;
        color: #666;
        line-height: 6.1vw;
        margin-bottom: 7vw;
        .y{
          position: absolute;
          top: 50%;
          right: 5.3vw;
          transform: translateY(-50%);
          height: 2.4vw;
          display: block;
        }
      }
      .kjClick{
        color: #5892FF;
      }
    }
    .block{
      height: 17.6vw;
      width: 100%;
      position: absolute;
      bottom: 0;
      left: 0;
      background: linear-gradient(0deg, #FFFFFF, rgba(255,255,255,0));
    }
  }
  .bottom-button2{
    width: 52vw;
    height: 13vw;
    background: #5892FF;
    border-radius: 999px;
    margin: 4.5vw auto 0 auto;
    line-height: 13vw;
    text-align: center;
    font-size: 4vw;
    color: #fff;
  }
  .bottom-button1{
    width: 52vw;
    height: 13vw;
    background: #E6E6E6;
    border-radius: 999px;
    margin: 4.5vw auto 0 auto;
    line-height: 13vw;
    text-align: center;
    font-size: 4vw;
    color: #fff;
  }
}
.jz{
  text-align: center;
  padding: 10vw 0;
}
</style>
